import { ProjectStatus } from 'src/utils/types';
export const mapColor = {
  [ProjectStatus.UPCOMING]: '#A19EAD',
  [ProjectStatus.LIVE]: '#10FF00',
  [ProjectStatus.ENDED]: '#DB3047',
  [ProjectStatus.INACTIVE]: '',
  [ProjectStatus.REFUNDED]: ''
};